export { default } from './uuid';
//# sourceMappingURL=index.js.map